export default __webpack_public_path__ + "static/media/HDTX_LKTT 2018.54ba44b3.pdf";